"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = utils;
/**
 * The plugins who's contain all utils fonctions.
 * @namespace Thor.plugins.utils
 * @memberof Thor.plugins
 * @class
 */
function utils(Thor) {
  if (typeof window === "undefined") return;
  return {
    /**
     * Convert query url string to an object.
     * @method
     * @name Thor.plugins.utils.objectify
     * @param {String} str - String to convert.
     * @return {Object} With key and value content.
     *
     * @example thor.plugins.utils.objectify("firstName=John&lastName=Doe&age=50")
     * return: {firstName : "John", lastName : "Doe", age : 50}
     */
    objectify: function objectify(str) {
      var o = {},
        value,
        pairs,
        pair,
        keys,
        key,
        idx;
      var _separator = /&amp;|&/g,
        _delimiter = "=";
      if (str.search(_separator) !== -1) {
        pairs = str.split(_separator, -1);
      } else {
        if (str.length) {
          pairs = {};
          pairs[str] = str.toString();
        } else if (typeof str === "Array") {
          pairs = [str];
        } else {
          pairs = [];
        }
      }
      keys = Object.keys(pairs);
      for (var i = 0, l = keys.length; i < l; i += 1) {
        pair = decodeURIComponent(pairs[keys[i]].replace(/\+/g, "%20"));
        idx = pair.indexOf(_delimiter) !== -1 ? pair.indexOf(_delimiter) : str.length;
        key = pair.split(_delimiter, 1);
        value = pair.slice(idx + 1);
        o[key] = value;
      }
      return o;
    },
    /**
     * Get all the name of list with the value equals true.
     * @method
     * @name Thor.plugins.utils.find
     * @param {Array} list - The list of object to test.
     * @return {Array} the key's list matching.
     */
    find: function find() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var res = [];
      list.forEach(function (obj) {
        if (obj.value === true) {
          res.push(obj.name);
        }
      });
      return res;
    },
    /**
     * Create an hidden image into the body.
     * @method
     * @name Thor.plugins.utils.sendPx
     * @param {String} url - The url to call as an image.
     */
    sendPx: function sendPx(url) {
      var px = document.createElement('img');
      px.setAttribute('src', url);
      px.setAttribute('height', '1px');
      px.setAttribute('width', '1px');
      px.setAttribute('style', 'display:none');
      document.body.appendChild(px);
    },
    /**
     * Load cookie's value of the name params.
     * @method
     * @name Thor.plugins.utils.loadCookie
     * @param {String} name - The name of the cookie to load.
     * @return {String} The value of the cookie, by default return an empty string
     * @default empty string
     */
    loadCookie: function loadCookie(name) {
      var cookie = document.cookie.match(name + '=([^;$]*)');
      if (!!cookie && !!name) {
        return decodeURIComponent(cookie[1]);
      }
      return "";
    },
    /**
     * Get the value of the cookie "visitId".
     * @method
     * @name Thor.plugins.utils.getIdData
     * @return {String} The value of the visitId's cookie, by default return an empty string
     * @default empty string
     */
    getIdData: function getIdData() {
      return Thor.getInstance().plugins.utils.loadCookie('visitId');
    }
  };
}
;